/**
 * Partner pricing (owner decision 25 Sep 2026): confidential wholesale prices, shown only inside PartnerGate
 * (approved partners). The API answers 404 to anyone else, so nothing is fetched or rendered before approval.
 */
import { useSurface } from '../kit/context';
import { useResource } from '../kit/resource';
import { DataTable, Loadable, Money, Screen } from '../kit/ui';
import { usePartnerApi } from './layout';

export function PricingPage() {
  const { t } = useSurface();
  const api = usePartnerApi();
  const list = useResource('billing:wholesale', api.wholesale);
  return (
    <Screen title={t('portal.partners.pricing.title')} subtitle={t('portal.partners.pricing.subtitle')} testId="partner-pricing">
      <Loadable resource={list}>
        {(rows) => <DataTable rows={rows} rowKey={(r) => r.sku} empty={t('portal.partners.pricing.empty')} columns={[
          { key: 'n', header: t('portal.partners.pricing.product'), render: (r) => r.name },
          { key: 'w', header: t('portal.partners.pricing.wholesale'), render: (r) => <Money minor={r.wholesale.amountMinor} currency={r.wholesale.currency} /> },
          { key: 'm', header: t('portal.partners.pricing.markup'), render: (r) => `${(r.markupBps / 100).toFixed(2)}%` },
          { key: 'c', header: t('portal.partners.pricing.clientPrice'), render: (r) => <Money minor={r.clientPrice.amountMinor} currency={r.clientPrice.currency} /> },
        ]} />}
      </Loadable>
    </Screen>
  );
}
